import React, { useEffect } from "react";
import java from '../../../images/javaScript.png';
import reaCT from '../../../images/react.png';
import critical from '../../../images/intro.png';
import Aos from 'aos';
import "aos/dist/aos.css"

const BlogDetails = () => {

    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);

    return (
        <section className="project py-5 " style={{ background: "#white" }}>
            <div data-aos="fade-down" className="text-center project-header">
                <h1 className="pb-5">My Recent Blogs</h1>

            </div>
            <div data-aos="fade-down" className="row px-5 mx-3">

                <div className="row d-flex project-img inline-block">
                    <div data-aos="fade-down-right" className="col-md-4 lg-4 sm-12 ">
                        <img style={{ width: "30%" }} src={java} alt="" />
                        <h1>Some JavaScript Interview Questions</h1>
                        <h3>09/05/2021</h3>
                    </div>
                    <div data-aos="fade-down" className="col-md-4 lg-4 sm-12 py-4">
                        <h4>Features</h4>
                        <p className="px-2">
                            null vs undefined
                            Q: Could you tell me the differences between null and undefined?
                            Ans:-usually we can make 7 to 8 ways. the differences are given below
                            let maria;//no value has been set.
                        </p>
                        <div style={{ fontSize: "2rem", color: '#212529', textDecoration: "none" }} className="d-flex justify-content-center ">
                            <br />
                            <h4><a rel="noreferrer" href="https://tanjin-ahamed123.medium.com/some-javascript-interview-questions-2e77a31a09f8" target="_blank">read more...</a></h4>

                        </div>
                    </div>
                    <div data-aos="fade-down-left" className="col-md-4 lg-4 sm-12 project-img inline-block">
                        <p><img src={java} alt="Example2" width="100%" height="100%" /></p>
                    </div>

                </div>
                <div className="row d-flex project-img inline-block py-4">
                    <div data-aos="fade-right" className="col-md-4 lg-4 sm-12">
                        <h4>Features</h4>
                        <p className="px-2">
                            React
                            React is a javascript library for building UI. It is a declarative, efficient, and flexible javascript library. Every react application build depends on components. It’s also components-based architecture. It’s a virtual DOM that depends on elements’ behaviors.
                        </p>
                        <div style={{ fontSize: "2rem", color: '#212529' }} className="d-flex justify-content-center">
                            <h4><a rel="noreferrer" href="https://tanjin-ahamed123.medium.com/introduction-to-react-e2fe0ca8facd" target="_blank"> read more...</a></h4>

                        </div>
                    </div>
                    <div className="col-md-4 lg-4 sm-12 project-img">
                        <p data-aos="flip-left"><img src={reaCT} alt="Example2" width="100%" height="100%" /></p>
                    </div>
                    <div data-aos="fade-left" className="col-md-4 lg-4 sm-12">
                        <img style={{ width: "30%" }} src={reaCT} alt="" />
                        <h1>Introduction To React</h1>
                        <h3>08/05/2021</h3>
                    </div>
                </div>
                <div className="row d-flex project img-fluid py-4">
                    <div className="col-md-4 lg-4 sm-12 project-img">
                        <p data-aos="fade-up-right"><img src={critical} alt="Example2" width="100%" height="100%" /></p>
                    </div>
                    <div data-aos="fade-up" className="col-md-4 lg-4 sm-12">
                        <img style={{ width: "30%" }} src={critical} alt="" />
                        <h1>Some important method of Javascript</h1>
                        <h3>07/05/2021</h3>
                    </div>
                    <div data-aos="fade-up-left" className="col-md-4 lg-4 sm-12">
                        <h4>Features</h4>
                        <p className="px-2">
                            What is JavaScript?
                            JavaScript is a scripting or programming language that allows you to implement complex features on web pages. JavaScript can update and change both HTML and CSS. JavaScript can calculate, manipulate and validate data.
                        </p>
                        <div style={{ fontSize: "2rem", color: '#212529' }} className="d-flex justify-content-center">
                            <h4><a rel="noreferrer" href="https://tanjin-ahamed123.medium.com/some-important-method-of-javascript-e1039e1b066e" target="_blank"> read more...</a></h4>

                        </div>
                    </div>
                </div>

            </div>

        </section>
    );
};

export default BlogDetails;